module.exports = __webpack_public_path__ + "img/bg_tech_epowertrain@2x.4419e76c.jpg";